<template>
  <q-card flat class="q-pa-md">
    <div
      class="text-h6 text-bold q-px-sm"
      :class="$q.dark.mode ? 'text-grey-2' : 'text-primary'"
    >
      Dow Signals
      <p class="text-caption text-bold">
        As of : {{ $store.state.market.asOf }}
      </p>
    </div>
    <PackageAuth>
      <template #authorized-content>
        <div class="q-px-sm q-gutter-sm row">
          <q-select
            class="col-md-3 col-xs-12"
            v-model="buttonBuyOrSell"
            dense
            :hint="'Signal Type'"
            label="buy/sell"
            outlined
            :options="['buy', 'sell']"
          ></q-select>
        </div>
        <div class="row q-pb-sm">
          <div class="justify-left q-gutter-sm">
            <q-radio
              v-model="timePeriod"
              val="hourly"
              label="Hourly"
              color="red"
              keep-color
              disable
            />
            <q-radio
              v-model="timePeriod"
              val="daily"
              label="Daily"
              color="cyan"
              keep-color
            />
            <q-radio
              v-model="timePeriod"
              val="weekly"
              label="Weekly"
              color="cyan"
              keep-color
              disable
            />
          </div>
          <q-space />
        </div>

        <q-card flat bordered>
          <q-tabs
            v-model="tab"
            dense
            inline-label
            outside-arrows
            mobile-arrows
            :class="$q.dark.mode ? 'bg-grey-10' : 'text-grey-9 bg-grey-4'"
            active-color="white"
            :active-bg-color="$q.dark.mode ? 'grey-9' : 'blue-4'"
            :indicator-color="$q.dark.mode ? 'grey-7' : 'blue-5'"
            align="justify"
            narrow-indicator
          >
            <q-tab name="dow_signal_alert" label="Dow Signal Alert" no-caps />
            <q-tab name="dow_signal" label="Dow Signal" no-caps />
          </q-tabs>

          <q-separator></q-separator>

          <q-tab-panels v-model="tab" animated>
            <q-tab-panel class="q-pa-xs" name="dow_signal_alert">
              <DowSignalAlert
                :symbol="symbol"
                :timePeriod="timePeriod"
                :buttonBuyOrSell="buttonBuyOrSell"
              />
            </q-tab-panel>
            <q-tab-panel class="q-pa-xs" name="dow_signal">
              <DowSignal
                :symbol="symbol"
                :timePeriod="timePeriod"
                :buttonBuyOrSell="buttonBuyOrSell"
              />
            </q-tab-panel>
          </q-tab-panels>
        </q-card>
      </template>
    </PackageAuth>
  </q-card>
</template>

<script setup>
import { ref } from "vue";
import { useRoute } from "vue-router";
import { useQuasar } from "quasar";
import { useStore } from "vuex";

import DowSignal from "src/components/StockProfile/StockSignals/DowSignal/DowSignal.vue";
import DowSignalAlert from "src/components/StockProfile/StockSignals/DowSignal/DowSignalAlert.vue";
import PackageAuth from "src/components/Packages/PackageAuth.vue";

const $q = useQuasar();
const $route = useRoute();
const $store = useStore();

const props = defineProps({
  symbol: {
    type: String,
  },
});

const tab = ref($route.query?.type || "dow_signal_alert");

let timePeriod = ref("daily");
timePeriod.value = ref($route.query?.t || "daily")._value;
let buttonBuyOrSell = ref("buy");
buttonBuyOrSell.value = ref($route.query?.s || "buy")._value;
</script>
